'use strict';
var parent = require('../../stable/object/get-own-property-descriptor');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/object/get-own-property-descriptor.js
// module id = 544
// module chunks = 13